module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("panels"), _vm._v(" "), _vm._t("gallery"), _vm._v(" "), _vm._t("settings"), _vm._v(" "), _vm._t("add-btn"), _vm._v(" "), _vm._t("modals"), _vm._v(" "), _c('fab-speed-dial', {
    attrs: {
      "position-type": "fixed",
      "icon-size": "small",
      "position": _vm.position,
      "bg-color": _vm.bgColor,
      "actions": _vm.fabActions
    },
    on: {
      "addNewPanel": _vm.handleAddPanel,
      "addOnAir": _vm.handleAddOnAir,
      "addActivityFeed": _vm.handleAddActivityFeed,
      "addTwitterTrends": _vm.handleAddTwitterTrends,
      "addInstantPoll": _vm.handleAddInstantPoll,
      "addChat": _vm.handleAddChat
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62f9d085","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/interaction/Dashboard.vue
// module id = 3308
// module chunks = 3